import { Col, Row } from 'antd';
import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { Trans, withNamespaces } from 'react-i18next';
import { connect } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';

import { handleApiErrors } from '../../api/axiosInstance';
import { cancelPlanAtPeriodEnd } from '../../api/subscription';
import Button from '../../components/Button';
import Text from '../../components/Text';
import LinkText from '../../components/Text/LinkText';
import Toast from '../../components/Toast';
import PageContainer from '../../containers/PageContainer';
import { INTERNAL_LINKS } from '../../enum';
import withAuthentication from '../../hocs/withAuthentication';
import { saveCompany, updateCompanyPlan } from '../../stores/actions/common';
import { formatPageTitle, momentFormat } from '../../utils/common';
import classNames from './style.module.scss';

const ConfirmPlanCancellationView = props => {
  const { t, currentPlan, currentCompany, updatePlan, history } = props;

  const [isCancellingPlan, setIsCancellingPlan] = useState(false);

  const handlePlanCancelleation = async () => {
    setIsCancellingPlan(true);
    try {
      const updatedPlan = await cancelPlanAtPeriodEnd(currentCompany._id);
      updatePlan(updatedPlan);
      Toast({
        type: 'error',
        message: t('cancelledSuccessfully'),
      });
      history.push(INTERNAL_LINKS.PRICE_PLANS);
    } catch (error) {
      handleApiErrors(error.response, () => {
        Toast({
          type: 'error',
          message: t('subCancellationError'),
        });
      });
    }
    setIsCancellingPlan(false);
  };

  if (!currentPlan.isTrialActive && currentPlan.isCancelled) {
    Toast({
      type: 'error',
      message: t('subAlreadyCancelled'),
    });
    return <Redirect to={INTERNAL_LINKS.PRICE_PLANS} />;
  }

  if (!currentPlan || (currentPlan && currentPlan.isCancelled)) {
    return <Redirect to={INTERNAL_LINKS.PRICE_PLANS} />;
  }

  return (
    <PageContainer title={t('confirmSubscriptionCancellation')}>
      <Helmet>
        <title>{formatPageTitle('Confirm Subscription Cancellation')}</title>
      </Helmet>

      <div className={classNames.contentWrapper}>
        <Text className={classNames.paragraph} variant="p" size="medium">
          {t('confirmSubCancel_1')}
        </Text>
        <Text className={classNames.paragraph} variant="p" size="medium">
          {t('confirmSubCancel_2')}
        </Text>
        <Text className={classNames.paragraph} variant="p" size="medium">
          <Trans
            t={t}
            i18nKey="subEndDate"
            values={{
              endDate: momentFormat(currentPlan.estimatedEndDate, 'LL'),
              endTime: momentFormat(currentPlan.estimatedEndDate, 'hh:mm A'),
            }}
            components={[
              <Text variant="strong" size="medium">
                DummyText
              </Text>,
            ]}
          />
        </Text>
        <Text className={classNames.paragraph} variant="p" size="medium">
          {t('confirmSubCancel_3')}
        </Text>
        <Text className={classNames.paragraph} variant="p" size="medium">
          {t('confirmSubCancel_4')}
        </Text>

        <Row gutter={17} align="middle" justify="center">
          <Col>
            <Button
              loading={isCancellingPlan}
              disabled={isCancellingPlan}
              text={t('cancelKliksSub')}
              type="primary"
              onClick={handlePlanCancelleation}
            />
          </Col>

          <Col>
            <Text variant="p" size="medium">
              {t('-- or --')}
            </Text>
          </Col>

          <Col>
            <Link to={isCancellingPlan ? '#' : INTERNAL_LINKS.PRICE_PLANS}>
              <LinkText size="large">{t('dontCancelMySub')}</LinkText>
            </Link>
          </Col>
        </Row>
      </div>
    </PageContainer>
  );
};

const mapStateToProps = (state, ownProps) => {
  return {
    currentCompany: state.common.currentCompany,
    currentPlan: state.common.companyData.companyPlan,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    updatePlan: newPlan => dispatch(updateCompanyPlan(newPlan)),
    updateCompany: companyInfo => dispatch(saveCompany(companyInfo)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withNamespaces()(withAuthentication(ConfirmPlanCancellationView)));
